import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import { SelectionControlGroup } from 'react-md';

const GroupingSelector = ({ value, onChange, intl }) => (
  <SelectionControlGroup
    id="selection-control-group-radios"
    controlClassName="md-inline-block"
    name="radio-example"
    type="radio"
    defaultValue="MONTHLY"
    value={value}
    onChange={onChange}
    controls={[{
      label: intl.formatMessage({ id: 'stats.grouping.dayly' }),
      value: 'DAYLY',
    }, {
      label: intl.formatMessage({ id: 'stats.grouping.weekly' }),
      value: 'WEEKLY',
    }, {
      label: intl.formatMessage({ id: 'stats.grouping.monthly' }),
      value: 'MONTHLY',
    }, {
      label: intl.formatMessage({ id: 'stats.grouping.dayOfWeek' }),
      value: 'DAY_OF_WEEK',
    }, {
      label: intl.formatMessage({ id: 'stats.grouping.hourOfDay' }),
      value: 'HOUR_OF_DAY',
    }, {
      label: intl.formatMessage({ id: 'stats.grouping.groupOfHourOfDay' }),
      value: 'GROUP_OF_HOUR_OF_DAY',
    }, {
      label: intl.formatMessage({ id: 'stats.grouping.limit' }),
      value: 'LIMIT',
    }]}
  />
);

GroupingSelector.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  intl: intlShape.isRequired,
};
export default injectIntl(GroupingSelector);



// WEBPACK FOOTER //
// ./src/components/Stats/GroupingSelector.js